import { useSpedAssessmentStart } from '@/core/domain/sped/sped-assessment/sped-assessment.hooks';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button } from 'antd';

export default function SpedDocumentStartAnalysis() {
  const spedDocument = useSpedDocumentContext();

  const spedAssesmentStart = useSpedAssessmentStart();

  const hasPermission = hasPermissions([
    Authorities.SPED_DOCUMENT_START_ANALYSIS,
  ]);

  const start = async () => {
    if (!spedDocument) return;

    await spedAssesmentStart.mutateAsync(spedDocument?.id);
  };

  return (
    <Button
      type="primary"
      onClick={start}
      loading={spedAssesmentStart.isLoading}
      disabled={!hasPermission}
    >
      {spedAssesmentStart.isLoading ? 'Executando...' : 'Iniciar apuração'}
    </Button>
  );
}
